// ------------------------
// HERO SECTION TYPEWRITER EFFECT
// ------------------------

import Typewriter from '/node_modules/typewriter-effect/dist/core';

new Typewriter('#typewriter', {
  strings: ['Reinvent', 'Recreate', 'Rediscover'],
  autoStart: true,
  loop: true,
  delay: 70,
});